// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.matching-request-page {
  padding-bottom: var(--space-6, 24px);
}

/* Keeps the title centered; the right-hand twin of the back button is invisible */
.matching-request-page .ttbFormHeaderSpacer {
  visibility: hidden;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/MatchingRequest/MatchingRequestPage.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":[".matching-request-page {\n  padding-bottom: var(--space-6, 24px);\n}\n\n/* Keeps the title centered; the right-hand twin of the back button is invisible */\n.matching-request-page .ttbFormHeaderSpacer {\n  visibility: hidden;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
